import { selectors } from 'modules/common';

export const getDelegateByUser = (
    company: selectors.types.ExpandedCompany,
    user: selectors.types.ExpandedCompanyUser
) => {
    return company.delegates.find(
        (delegate) => delegate.delegateUserId === user.delegateUserId && delegate.userId === user.id
    );
};
